<template>
    <div class="nav-content-wrapper" v-if="!$store.state.waitingRequest">
        <admin-navbar />
        
        <div class="content">    
            <h2>Commentaires publiés</h2>
            
            <table border="1">
                <tr>
                    <th>Titre</th>
                    <th>Image</th>
                    <th>Pseudo</th>
                    <th>Message</th>
                    <th>Date d'ajout</th>
                    <th>Supprimer</th>
                </tr>
                <tr v-for="comment in comments" :key="comment.id">
                    <td>{{ comment.game_title }}</td>
                    <td><a :href="'/games/'+comment.game_title_url" target="_blank"><img :src="'/games/static/miniatures/'+comment.game_image_url"></a></td>
                    <td>{{ comment.pseudo }}</td>
                    <td>{{ comment.message }}</td>
                    <td>{{ comment.created_at }}</td>
                    <td><a href="#" @click.prevent="deleteComment(comment)"><i class="fas fa-times-circle"></i></a></td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import Session from '../mixins/adminSession';
    import AdminNavbar from '../views/AdminNavbar';

    export default {
        name: 'AdminEditComments', 
        mixins: [Session],
        components: {
            'admin-navbar': AdminNavbar
        },
        data() {
            return {
                comments: []
            }
        },
        mounted() {
            this.getCommentsAdmin();
        },
        methods: {
            getCommentsAdmin() {
                let formData = new FormData();
                formData.append('data', JSON.stringify({post: "1"}));
                
                axios
                .post(
                this.$store.state.apiUrl+"?request=getCommentsAdmin", formData
                )
                .then((response) => {
                    if(response.data.length > 0) {
                        this.comments = response.data;
                    }
                });
            },
            deleteComment(comment) {
                if (confirm('Souhaitez-vous vraiment supprimer le commentaire de "'+ comment.pseudo +'" ?')) {
                    let formData = new FormData();
                    formData.append('data', JSON.stringify({
                        post: "1",
                        commentId: comment.id
                    }));
                    
                    axios
                    .post(this.$store.state.apiUrl+"?request=deleteComment", formData)
                    .then((response) => {
                        if(response.data) {
                            this.getCommentsAdmin();
                        }
                    });
                }
            }
        }
    }
</script>

<style scoped src="@/assets/admin.css">
</style>
